<div class="carousel">
  <ng-container *ngFor="let item of items; let i = index">
    <div class="carousel__item" [@carousel]="direction" *ngIf="i === index">
      <ng-container [ngTemplateOutlet]="item"></ng-container>
    </div>
  </ng-container>
</div>
